import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './level_2.css';
import Button from '../components/button';
import Instructions from '../components/instructions';
import Settings from '../components/settings';
import SoundVideo from '../components/sound_video';
import pause from '../assets/pause.png';
import arrow from '../assets/arrow.png';
import object1 from '../assets/object1.png';
import object2 from '../assets/object2.png';
import object3 from '../assets/object3.png';
import object4 from '../assets/object4.png';
import girlBack from '../assets/girlback.png';
import cobra from '../assets/cobra2.png';
import ankh from '../assets/ankh2.png';
import cat from '../assets/cat2.png';
import falcon from '../assets/falcon2.png';
import eye from '../assets/eye2.png';
import level2WinVideo from '../assets/level2win.mp4';
import level2LoseVideo from '../assets/level2lose.mp4';
import ghost from '../assets/ghost.png';
import retry from '../assets/retry.png';
import homeButton from '../assets/homebutton.png';
import yellowStar from '../assets/yellowstar.png';
import treasure from '../assets/tressure.png';
import nextButton from '../assets/button2.png';
import money from '../assets/money.png';
import moneySound from '../assets/money.mp3';
import level2Instructions from '../assets/level2instructions.png';
import winSound from '../assets/winsound.m4a';
import loseSound from '../assets/losesound.mp3';
import lightSound from '../assets/lightsound.m4a';
import { play_sound, stop_sound } from '../audio_settings';
import { getLevelTime } from './level_time';

const LEVEL_TIME = getLevelTime(2);
const LEVEL_REWARD = 100;
const MONEY_STEP = 5;
const CORRECT_ORDER = ['cat', 'cobra', 'falcon'];
const STARTING_OBJECTS = [
  { id: 1, image: object1, x: 82, y: 120, width: 170 },
  { id: 2, image: object2, x: 78, y: 272, width: 112 },
  { id: 3, image: object3, x: 204, y: 348, width: 96 },
  { id: 4, image: object4, x: 220, y: 205, width: 130 }
];
const SYMBOLS = [
  { id: 'cobra', image: cobra },
  { id: 'ankh', image: ankh },
  { id: 'cat', image: cat },
  { id: 'falcon', image: falcon },
  { id: 'eye', image: eye }
];

const Level2 = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const setMoneyCount = props.setMoneyCount;
  const [showInstructions, setShowInstructions] = useState(true);
  const [showPause, setShowPause] = useState(false);
  const [objects, setObjects] = useState(STARTING_OBJECTS);
  const [dragging, setDragging] = useState(null);
  const [timeLeft, setTimeLeft] = useState(LEVEL_TIME);
  const [selectedSymbols, setSelectedSymbols] = useState([]);
  const [gainingMoney, setGainingMoney] = useState(false);
  const [wallPressed, setWallPressed] = useState(false);
  const moneyAudioRef = useRef(null);
  const moneyIntervalRef = useRef(null);
  const moneyAwardedRef = useRef(0);
  const winAudioRef = useRef(null);
  const loseAudioRef = useRef(null);
  const lightAudioRef = useRef(null);
  const symbolsScreen = location.pathname.includes('/level_2/symbols');
  const winVideo = location.pathname === '/level_2/symbols/win-video';
  const loseVideo = location.pathname.includes('/lose-video');
  const won = location.pathname === '/level_2/symbols/win';
  const lost = location.pathname === '/level_2/wall/lose' || location.pathname === '/level_2/symbols/lose';
  const resultActive = winVideo || loseVideo || won || lost;

  useEffect(() => {
    if (showInstructions || showPause || props.showSettings || resultActive) return;

    const timer = window.setInterval(() => {
      setTimeLeft((time) => {
        if (time === 1) {
          navigate(symbolsScreen ? '/level_2/symbols/lose-video' : '/level_2/wall/lose-video');
        }

        return time - 1;
      });
    }, 1000);

    return () => window.clearInterval(timer);
  }, [navigate, props.showSettings, resultActive, showInstructions, showPause, symbolsScreen]);

  useEffect(() => {
    if (
      !won
      || showPause
      || props.showSettings
      || moneyAwardedRef.current >= LEVEL_REWARD
    ) return;

    const moneyAudio = moneyAudioRef.current;
    setGainingMoney(true);
    play_sound(moneyAudio, { restart: moneyAwardedRef.current === 0 });

    const moneyInterval = window.setInterval(() => {
      moneyAwardedRef.current += MONEY_STEP;
      setMoneyCount((count) => count + MONEY_STEP);

      if (moneyAwardedRef.current >= LEVEL_REWARD) {
        window.clearInterval(moneyInterval);
        setGainingMoney(false);
      }
    }, 80);
    moneyIntervalRef.current = moneyInterval;

    return () => {
      window.clearInterval(moneyInterval);
      moneyAudio.pause();
      setGainingMoney(false);
    };
  }, [props.showSettings, setMoneyCount, showPause, won]);

  useEffect(() => {
    const resultAudio = won
      ? winAudioRef.current
      : lost
        ? loseAudioRef.current
        : null;

    if (!resultAudio) return;

    play_sound(resultAudio);
    return () => stop_sound(resultAudio);
  }, [lost, won]);

  useEffect(() => {
    const resultAudio = won
      ? winAudioRef.current
      : lost
        ? loseAudioRef.current
        : null;

    if (!resultAudio) return;

    if (showPause || props.showSettings) {
      resultAudio.pause();
    } else {
      play_sound(resultAudio, { restart: false });
    }
  }, [lost, props.showSettings, showPause, won]);

  useEffect(() => {
    const moneyAudio = moneyAudioRef.current;
    const lightAudio = lightAudioRef.current;
    const winAudio = winAudioRef.current;
    const loseAudio = loseAudioRef.current;

    const stopDisabledSounds = (event) => {
      if (event.detail.name === 'sound' && !event.detail.value) {
        stop_sound(moneyAudio);
        stop_sound(lightAudio);
        stop_sound(winAudio);
        stop_sound(loseAudio);
      }
    };

    window.addEventListener('audio_setting_change', stopDisabledSounds);

    return () => {
      window.removeEventListener('audio_setting_change', stopDisabledSounds);
      stop_sound(moneyAudio);
      stop_sound(lightAudio);
      stop_sound(winAudio);
      stop_sound(loseAudio);
    };
  }, []);

  useEffect(() => {
    if (symbolsScreen || showPause || props.showSettings || resultActive) {
      setWallPressed(false);
      stop_sound(lightAudioRef.current);
    }
  }, [props.showSettings, resultActive, showPause, symbolsScreen]);

  const startWallLight = (event) => {
    if (showInstructions || showPause || props.showSettings || resultActive) return;

    event.currentTarget.setPointerCapture(event.pointerId);
    setWallPressed(true);
    play_sound(lightAudioRef.current, { loop: true });
  };

  const stopWallLight = () => {
    setWallPressed(false);
    stop_sound(lightAudioRef.current);
  };

  const startDragging = (event, object) => {
    const levelBounds = event.currentTarget.parentElement.getBoundingClientRect();
    setDragging({
      id: object.id,
      offsetX: event.clientX - levelBounds.left - object.x,
      offsetY: event.clientY - levelBounds.top - object.y
    });
  };

  const dragObject = (event) => {
    if (!dragging) return;

    const levelBounds = event.currentTarget.getBoundingClientRect();
    setObjects((currentObjects) => currentObjects.map((object) => (
      object.id === dragging.id
        ? {
            ...object,
            x: event.clientX - levelBounds.left - dragging.offsetX,
            y: event.clientY - levelBounds.top - dragging.offsetY
          }
        : object
    )));
  };

  const selectSymbol = (symbol) => {
    const nextSymbols = [...selectedSymbols, symbol];
    setSelectedSymbols(nextSymbols);

    if (nextSymbols.length === CORRECT_ORDER.length) {
      const correct = nextSymbols.every((selectedSymbol, index) => selectedSymbol.id === CORRECT_ORDER[index]);
      navigate(correct ? '/level_2/symbols/win-video' : '/level_2/symbols/lose-video');
    }
  };

  const retryLevel = () => {
    stopWallLight();
    moneyAwardedRef.current = 0;
    setObjects(STARTING_OBJECTS);
    setSelectedSymbols([]);
    setTimeLeft(LEVEL_TIME);
    navigate('/level_2/wall');
  };

  const finishLevel = () => {
    props.unlockLevel3();
    navigate('/levels');
  };

  const timerText = `${Math.floor(timeLeft / 60)}:${String(timeLeft % 60).padStart(2, '0')}`;
  const timerIsUrgent = timeLeft > 0 && timeLeft <= 10;

  return (
    <div
      className={`level_2${symbolsScreen ? ' level_2_screen_2' : ''}${wallPressed ? ' level_2_wall_pressed' : ''}`}
      onPointerMove={dragObject}
      onPointerUp={() => setDragging(null)}
    >
      <audio ref={moneyAudioRef} src={moneySound} />
      <audio ref={winAudioRef} src={winSound} />
      <audio ref={loseAudioRef} src={loseSound} />
      <audio ref={lightAudioRef} src={lightSound} />

      {!symbolsScreen && (
        <>
          <button
            className="level_2_wall"
            type="button"
            data-no-feedback
            onPointerDown={startWallLight}
            onPointerUp={stopWallLight}
            onPointerCancel={stopWallLight}
            onLostPointerCapture={stopWallLight}
          />

          {objects.map((object) => (
            <img
              className="level_2_object"
              key={object.id}
              src={object.image}
              alt=""
              draggable="false"
              data-interactive
              style={{ left: object.x, top: object.y, width: object.width }}
              onPointerDown={(event) => startDragging(event, object)}
            />
          ))}

          <button className="level_2_next" type="button" onClick={() => navigate('/level_2/symbols')}>
            <img src={arrow} alt="Next" />
          </button>
        </>
      )}

      {symbolsScreen && (
        <>
          <img className="level_2_girl" src={girlBack} alt="" />

          <div className="level_2_steps">
            {[2, 1, 0].map((symbolIndex) => (
              <div className={`level_2_step level_2_step_${symbolIndex}`} key={symbolIndex}>
                {selectedSymbols[symbolIndex] && (
                  <img src={selectedSymbols[symbolIndex].image} alt={selectedSymbols[symbolIndex].id} />
                )}
              </div>
            ))}
          </div>

          <div className="level_2_symbols">
            {SYMBOLS.map((symbol) => (
              <button
                className="level_2_symbol"
                key={symbol.id}
                type="button"
                disabled={selectedSymbols.length === CORRECT_ORDER.length}
                onClick={() => selectSymbol(symbol)}
              >
                <img src={symbol.image} alt={symbol.id} />
              </button>
            ))}
          </div>
        </>
      )}

      <div className="level_2_top">
        <Button className="level_2_pause" onclick={() => {
          stopWallLight();
          setDragging(null);
          setShowPause(true);
        }}>
          <img src={pause} alt="Pause" />
        </Button>
        {won ? (
          <div className={`level_2_money ${gainingMoney ? 'level_2_money_active' : ''}`}>
            <img src={money} alt="" />
            <span>{props.moneyCount}</span>
          </div>
        ) : (
          <div className={`level_2_timer${timerIsUrgent ? ' timer_urgent' : ''}`}>
            <span>{timerText}</span>
          </div>
        )}
      </div>

      {props.showSettings && (
        <Settings onclose={() => props.setShowSettings(false)} />
      )}

      {showInstructions && (
        <Instructions
          className="level_2_instructions"
          backgroundImage={level2Instructions}
          title={<>Level 2<br />Instructions</>}
          text={[
            'Tap the wall to activate the alabaster staff and reveal hidden hieroglyphics.',
            'Some glowing symbols are fake clues. Find the real hieroglyphics and ignore the false ones.',
            'Read the true symbols from top to bottom to fill the steps. Only the correct order will open the door.'
          ]}
          onStart={() => setShowInstructions(false)}
        />
      )}

      {showPause && (
        <div className="pause_overlay">
          <div className="pause_panel">
            <h1>Paused</h1>
            <Button className="pause_menu_button" onclick={() => props.setShowSettings(true)}>Settings</Button>
            <Button className="pause_menu_button" onclick={() => navigate('/home')}>Home</Button>
            <Button className="pause_menu_button" onclick={() => navigate('/levels')}>Levels</Button>
            <Button className="pause_menu_button" onclick={() => setShowPause(false)}>Resume</Button>
          </div>
        </div>
      )}

      {(winVideo || loseVideo) && (
        <div className="level_2_video_overlay">
          <SoundVideo
            className="level_2_video"
            src={loseVideo ? level2LoseVideo : level2WinVideo}
            autoPlay
            paused={showPause || props.showSettings}
            playsInline
            onEnded={() => navigate(
              loseVideo
                ? symbolsScreen ? '/level_2/symbols/lose' : '/level_2/wall/lose'
                : '/level_2/symbols/win'
            )}
          />
        </div>
      )}

      {(won || lost) && (
        <div className="level_2_result_overlay">
          <div className="level_2_result_panel">
            {lost ? (
              <>
                <h1>You Lose!</h1>
                <img className="level_2_result_ghost" src={ghost} alt="" />
                <div className="level_2_result_actions">
                  <Button className="level_2_result_button" onclick={retryLevel}>
                    <img src={retry} alt="Retry" />
                  </Button>
                  <Button className="level_2_result_button" onclick={() => navigate('/home')}>
                    <img src={homeButton} alt="Home" />
                  </Button>
                </div>
              </>
            ) : (
              <>
                <h1>Level<br />Completed!</h1>
                <div className="level_2_result_stars">
                  <img src={yellowStar} alt="" />
                  <img src={yellowStar} alt="" />
                  <img src={yellowStar} alt="" />
                </div>
                <img className="level_2_result_treasure" src={treasure} alt="" />
                <div className="level_2_result_actions">
                  <Button className="level_2_result_button" onclick={retryLevel}>
                    <img src={retry} alt="Retry" />
                  </Button>
                  <Button className="level_2_result_button" onclick={finishLevel}>
                    <img src={nextButton} alt="Next level" />
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

    </div>
  );
};

export default Level2;
